import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  FlatList,
  StyleSheet,
  Keyboard,
  Image
} from "react-native";
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";
import Colors from "../../../../../constants/colors";
import ShieldIcon from "../../../../../../../../assets/images/shield.png";
import { ComponentStyles } from "../../../../../constants/componentStyles";
import  FloatingTextInputComponent from "../../../common/FloatingTextInputComponent";

type Props = {
  onValidationChange?: (isValid: boolean) => void;
};

 

const ReceiverAddressStep: React.FC = ({ onValidationChange }: Props) => {
  const { t } = useTranslation();
  // display the field label from the gffpFieldsByCategory (from gffp response)
  const gffpFieldsByCategory = useSessionStore((s: SessionState) => (s as any).gffpFieldsByCategory);
  const receiverInfoFields: any[] = (gffpFieldsByCategory?.["Receiver Information"]) || [];
  const getFieldLabel = (tag: string): string | undefined => {
    const field = receiverInfoFields.find((f: any) => (f.XmlTag ?? f.xmlTag) === tag);
    return field?.FieldLabel ?? field?.fieldLabel;
  };

  const addressPlaceholder = getFieldLabel("senderAddress") || "Address";
  const cityPlaceholder = getFieldLabel("senderCity") || t("SENDER_ADDRESS_CITY_PLACEHOLDER");
  const postalPlaceholder = getFieldLabel("senderZipCode") || t("SENDER_ADDRESS_POSTAL_PLACEHOLDER");
  const statePlaceholder = getFieldLabel("senderState") || t("SENDER_ADDRESS_STATE_PLACEHOLDER");
  const [query, setQuery] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const receiverAddress = useSessionStore((s: SessionState) => (s as any).receiverAddress) || "";
  const receiverCity = useSessionStore((s: SessionState) => (s as any).receiverCity) || "";
  const receiverZipCode = useSessionStore((s: SessionState) => (s as any).receiverZipCode) || "";
  const receiverState = useSessionStore((s: SessionState) => (s as any).receiverState) || "";
  const setReceiverAddress = useSessionStore((s: SessionState) => (s as any).setReceiverAddress);
  const setReceiverCity = useSessionStore((s: SessionState) => (s as any).setReceiverCity);
  const setReceiverZipCode = useSessionStore((s: SessionState) => (s as any).setReceiverZipCode);
  const setReceiverState = useSessionStore((s: SessionState) => (s as any).setReceiverState);

  const isValid = receiverAddress.trim().length > 0 &&
    receiverCity.trim().length > 0 &&
    receiverZipCode.trim().length > 0 &&
    receiverState.trim().length > 0 && receiverState.trim().length <= 2;
  
    useEffect(() => {
      if (onValidationChange) {
        onValidationChange(isValid);
      }
    }, [isValid, onValidationChange]);
  

  const handleSearch = (text: string) => {
    setQuery(text);
    if (text.length > 1) {
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };


  const handleFieildChange = (text: string) => {
    let isContinue = false;
    if (receiverAddress?.length > 1 &&
      receiverCity?.length > 1 &&
      receiverZipCode?.length > 1 &&
      receiverState?.length > 1) {
      isContinue = true
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{t("SENDER_ADDRESS_TITLE")}</Text>
      <Text style={styles.subtitle}>{t("SENDER_ADDRESS_SUBTITLE")}</Text>

      {/* Search Field 
      <TextInput
        style={styles.input}
        placeholder="Search"
        value={query}
        onChangeText={handleSearch}
      />*/}

      {/* Suggestions List 
      {showSuggestions && (
        <FlatList
          data={suggestions}
          keyExtractor={(_, idx) => idx.toString()}
          renderItem={({ item }) => (
            <TouchableOpacity
              style={styles.suggestionItem}
              onPress={() => handleSelectSuggestion(item)}
            >
              <Text style={styles.suggestionText}>
                {item.address}, {item.city}, {item.state}
              </Text>
            </TouchableOpacity>
          )}
        />
      )}*/}

      {/* Manual Entry Fields */}
        
        <View style={styles.form}>
          <FloatingTextInputComponent
            testID="receiverAddress"
            label={addressPlaceholder}
            value={receiverAddress}
            onChangeText={(val) => { try { setReceiverAddress?.(val); } catch {} }}
          />

          <FloatingTextInputComponent
            testID="receiverCity"
            label={cityPlaceholder}
            value={receiverCity}
            onChangeText={(val) => { try { setReceiverCity?.(val); } catch {} }}
          />
          <FloatingTextInputComponent
            testID="receiverZipCode"
            label={postalPlaceholder}
            value={receiverZipCode}
            onChangeText={(val) => { try { setReceiverZipCode?.(val); } catch {} }}
          />
          <FloatingTextInputComponent
            testID="receiverState"
            label={statePlaceholder}
            value={receiverState}
            onChangeText={(val) => { try { setReceiverState?.(val); } catch {} }}
          />
        </View>
      

      <View style={styles.hintBox}>
        <Image
          source={ShieldIcon}
          style={{height: 24, width: 24, marginHorizontal: 16}}        
        />
        <Text style={styles.hintText}>
          {t("YOUR_INFO_IS_ALWAYS_KEPT_PRIVATE")}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
    paddingHorizontal: 24,
  },
  title: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.titleFont,
    fontWeight: '500', 
    color: Colors.titleTextColor,
    lineHeight: 34,
    marginBottom: 8
  },
  subtitle: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.subTitleFont,
    fontWeight: '400',
    lineHeight: 24,
    color: Colors.subTitleColor,
    marginBottom: 24
  },
  input: {
    backgroundColor: "#f5f5f5",
    padding: 12,
    borderRadius: 8,
    fontSize: 16,
    marginBottom: 10,
  },
  suggestionItem: { padding: 12, borderBottomWidth: 1, borderColor: "#eee" },
  suggestionText: { fontSize: 16 },
  form: { marginTop: 16},
  manualBtn: { marginTop: 16, alignItems: "center" },
  manualText: { fontSize: 16, fontWeight: "600" },
  infoBox: {
    marginTop: 20,
    padding: 12,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 8,
  },
  infoText: { fontSize: 14, color: "#333" },
  hintBox: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: Colors.titleTextColor,
    borderRadius: 10,
    padding: 12,
    marginTop: 32,
    backgroundColor: Colors.white,
    marginBottom: 79
  },
  hintText: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: 14,
    fontWeight: '400', 
    color: Colors.darkGrey,
    lineHeight: 18,
    paddingRight: 50
  },
});

export default ReceiverAddressStep;